import { ReactNode } from 'react';
import { Box } from '@material-ui/core';

interface Props {
    children: ReactNode;
}

function PageTitle(props: Props) {
    return (
        <Box display="flex" flexDirection="row" marginBottom={2} alignItems="center" justifyContent="space-between">
            {props.children}
        </Box>
    );
}

export default PageTitle;